import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Environment } from '../../../../core/env/environment';
import { getDefaultBrandId } from '../../../../core/env/brand';

export const useNavigationBarStyles = makeStyles<
  Theme,
  { environment?: Environment; hideBottomBorder?: boolean; isSelected?: boolean }
>((theme) => ({
  root: {
    borderBottom: ({ hideBottomBorder }) => (hideBottomBorder ? 'none' : '1px solid hsla(0,0%,100%,.1)'),
    width: '100%',
    background: ({ environment }) =>
      `url('/media/brands/${environment?.brand ?? getDefaultBrandId()}/background.png') no-repeat top / 100% auto`,
    backgroundSize: '100%',
    backgroundPosition: 'top'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '0px',
    paddingBottom: '0px',

    [theme.breakpoints.up('md')]: {
      paddingTop: '16px',
      paddingBottom: '16px'
    }
  },
  menuButton: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    },

    marginLeft: '-12px',

    '& .MuiSvgIcon-root': {
      fontSize: '3rem',
      color: 'white'
    }
  },
  menuItemsDesktop: {
    display: 'none',

    [theme.breakpoints.up('md')]: {
      display: 'flex'
    },

    marginLeft: '28px',

    justifyContent: 'center',
    alignItems: 'center'
  },
  menuItemsMobile: {
    minWidth: '200px',
    marginTop: '52px'
  },
  lhs: {
    display: 'flex'
  },
  rhs: {
    display: 'flex',
    alignItems: 'center'
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  projectSelector: {
    marginRight: '14px'
  },
  logo: {
    height: '40px',
    maxWidth: '50px',
    cursor: 'pointer'
  }
}));
